import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import {
  ascend,
  compose,
  filter,
  head,
  includes,
  groupWith,
  sortWith,
  descend,
  prop,
  sum,
  map,
  defaultTo,
  path,
  uniq,
  keys,
} from 'ramda';

import { apiGetCEUsFromReportingPeriod, apiAdminGetCEUsFromReportingPeriod } from '../../../../../api/ceu';
import { routes } from '../../../../index';

import Card from '../../../../../components/Card';

class CEUListCard extends Component {
  static propTypes = {
    creditTypes: PropTypes.array,
  };

  state = {
    currentReportingPeriod: null,
    reportingPeriods: [],
    loaded: false,
  };

  componentDidMount() {
    const { match } = this.props;
    const selectedUserId = match.params.userId;
    const fetchCertification = selectedUserId ? apiAdminGetCEUsFromReportingPeriod : apiGetCEUsFromReportingPeriod;
    fetchCertification({ userId: selectedUserId }).then(({ data }) =>
      this.setState({
        loaded: true,
        ...data,
      }),
    );
  }

  onChangeReportingPeriod(id) {
    const { match } = this.props;
    const selectedUserId = match.params.userId;
    const fetchCertification = selectedUserId ? apiAdminGetCEUsFromReportingPeriod : apiGetCEUsFromReportingPeriod;
    fetchCertification({ userId: selectedUserId, reportingPeriodId: id }).then(({ data }) =>
      this.setState({ ...data }),
    );
  }

  renderInfoRow = (name, value) => {
    if (!value) return <noscript />;

    return (
      <p>
        <strong>{name}:</strong> {value}
      </p>
    );
  };

  render() {
    if (!this.state.loaded) return <noscript />;
    const { creditTypes } = this.props;
    const { currentReportingPeriod, reportingPeriods, credits, minimums, total, earned } = this.state;
    const ceus = compose(
      groupWith((a, b) => a.creditTypeId == b.creditTypeId),
      sortWith([ascend(prop('creditTypeId')), descend(prop('completionDate'))]),
    )(credits);
    const usedCreditTypes = compose(uniq, map(prop('creditTypeId')))(credits);
    const creditTypesWithMin = filter(
      (creditType) => minimums[creditType.id] > 0 && !includes(creditType.id, usedCreditTypes),
      creditTypes,
    );
    const filteredReportingPeriods = filter(
      (reportingPeriod) => !moment(reportingPeriod.start).isAfter(moment()),
      reportingPeriods,
    );

    return (
      <Card className="mb-4">
        <Card.Header flex>
          <div className="flex-grow-1">
            {currentReportingPeriod.name} CEUs
            <br />
            <span className="subheader">
              <strong>Totals:</strong> {earned} of {total}
            </span>
          </div>
          <select
            className="form-control form-control-sm w-auto"
            onChange={(event) => this.onChangeReportingPeriod(Number(event.target.value))}
            value={currentReportingPeriod.id}
          >
            {filteredReportingPeriods.map((period) => (
              <option key={period.id} value={period.id}>
                {period.name}
              </option>
            ))}
          </select>
        </Card.Header>
        <Card.Body>
          <div className="table-responsive">
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>Program Title</th>
                  <th>Sponsor</th>
                  <th>Credits</th>
                  <th>Completion Date</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {ceus.length == 0 && creditTypesWithMin.length == 0 ? (
                  <tr>
                    <td colSpan="4" className="text-center font-weight-bold">
                      No CEUs found for this reporting period
                    </td>
                  </tr>
                ) : (
                  <Fragment>
                    {creditTypesWithMin.map((creditType) => {
                      const minimum = minimums[creditType.id];

                      return (
                        <tr key={creditType.id} className="table-info font-weight-bold">
                          <td colSpan={5}>
                            {creditType.name} ({`0 of ${minimum}`})
                          </td>
                        </tr>
                      );
                    })}
                    {ceus.map((creditGroup) => {
                      const header = head(creditGroup);
                      const creditType = defaultTo({ name: 'General' }, header.creditType);
                      const totalCredits = sum(creditGroup.map((ceu) => (ceu.approved ? ceu.credits : 0)));
                      const minimum = minimums[creditType.id];

                      return (
                        <Fragment key={header.creditTypeId}>
                          <tr className={`${minimum ? 'table-info' : 'table-active'} font-weight-bold`}>
                            <td colSpan={5}>
                              {creditType.name} ({totalCredits}
                              {minimum > 0 ? ` of ${minimum}` : ''})
                            </td>
                          </tr>
                          {creditGroup.map((ceu) => (
                            <tr key={ceu.id}>
                              <td>{ceu.programTitle}</td>
                              <td>{ceu.sponsor}</td>
                              <td>{ceu.credits}</td>
                              <td>{ceu.completionDate}</td>
                              <td>
                                {ceu.approved !== true ? (
                                  <Link className="btn btn-link btn-sm" to={routes.ceus.individual.editBuilder(ceu.id)}>
                                    {defaultTo('Pending', ceu.status)}
                                  </Link>
                                ) : (
                                  ''
                                )}
                              </td>
                            </tr>
                          ))}
                        </Fragment>
                      );
                    })}
                  </Fragment>
                )}
              </tbody>
            </table>
          </div>
          <Link className="btn btn-primary float-sm-right" to={routes.ceus.individual.add}>
            Add CEU
          </Link>
        </Card.Body>
      </Card>
    );
  }
}

export default withRouter(CEUListCard);
